export enum ExperimentStatusDefinition {
  Draft = 'Draft',
  Errored = 'Errored',
  Finished = 'Finished',
  Running = 'Running',
}

export type ExperimentStatusTab = {
  id: ExperimentStatusDefinition[];
  label: string;
};
